// extracted by mini-css-extract-plugin
export default {"automaticTileReorderingImage":"EbCmwkd6cB","adminView":"GPGUmAMlIx","userViewNoReordering":"Bkn8RlmxsC","userViewReorderingApplied":"kKFfTFLfyg","toggleWithMessage":"FYGrx4pQwL"};